<template>
  <div>
    <Slider />
    <section class="p-10 bg-white">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-sm font-bold text-gray-600 uppercase">About Us</h2>
        <hr class="w-16 mb-8 border-purple" style=" border-top-width: 3px !important;">
        <h1 class="mt-2 text-3xl font-semibold text-black">Let Us Introduce Ourselves.</h1>
        <p class="mt-4 leading-relaxed text-gray-600">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel
          facilisis. Ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </div>
    </section>

    <section class="container max-w-4xl p-10 mx-auto rounded-lg bg-purple">
      <div class="max-w-4xl px-5 mx-auto">
        <!-- MUO Mission Section -->
        <div class="mb-8">
          <h2 class="text-xl font-bold text-white uppercase">MUO Mission</h2>
          <hr class="w-32 mb-4 border-white" style=" border-top-width: 3px !important;">
          <p class="mt-4 leading-relaxed text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor lorem ipsum dolor sit amet,
            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum
            suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Ut labore et
            dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.
          </p>
        </div>
        <!-- MUO Vision Section -->
        <div>
          <h2 class="text-xl font-bold text-white uppercase">MUO Vision</h2>
          <hr class="mb-4 border-white w-28" style=" border-top-width: 3px !important;">
          <p class="mt-4 leading-relaxed text-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor lorem ipsum dolor sit amet,
            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum
            suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Ut labore et
            dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
      </div>
    </section>


    <section class="p-8 my-8 bg-lightPink">
      <div class="max-w-4xl mx-auto">
        <!-- Title with Underline -->
        <h2 class="text-xl font-bold text-gray-800 uppercase">Partner Universities</h2>
        <div class="w-48 mb-4 border-b-2 border-purple"></div>

        <!-- Description Text -->
        <p class="leading-relaxed text-gray-700">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel
          facilisis. Ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
          
        </p>
      </div>
    </section>


    <section class="p-8">
      <div class="max-w-6xl mx-auto">
        <!-- Grid Layout for Boxes -->
        <div class="grid grid-cols-4 gap-6">
          <!-- Box 1 with Image/Logo -->
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="Magna Carta Business School" class="h-20">
          </div>

          <!-- Box 2 with Image/Logo -->
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>

          <!-- Empty Boxes -->
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
          <div class="flex items-center justify-center p-4 border-2 rounded-lg border-purple">
            <img src="@/assets/images/magna.png" alt="iQualify UK" class="h-20">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Slider from '@/components/Slider.vue';
export default {
  name: 'About',
  components: {
    Slider,
  },
}
</script>
<style scoped></style>